module.exports = __webpack_public_path__ + "tables/media/smileImg.013ee8fb.svg";